'use client';

import { StateCreator } from 'zustand';
import { type CartProductCardType } from 'app/components/ProductCard';

interface CartItemState {
    originalCartItems: CartItem[];
    completedCartItems: CartProductCardType[];
}

interface CartItemActions {
    updateCart: (
        originalCartItems: CartItem[],
        completedCartItems: CartProductCardType[]
    ) => void;
}

export type CartItemSlice = CartItemState & CartItemActions;

export const createCartItemSlice: StateCreator<CartItemSlice, [], [], CartItemSlice> = (
    set
) => ({
    originalCartItems: [],
    completedCartItems: [],
    updateCart: (originalCartItems, completedCartItems) => {
        set({ originalCartItems, completedCartItems });
    },
});
